<script setup>
import { computed } from 'vue';

const props = defineProps({
  action: {type: Function},
  purpose: {type: String, default: 'primary'},
  size: {type: String, default: 'default'},
  label: {type: String},
  inactive: {type: Boolean, default: false}
})

const classes = computed(() => {
  return {
    'dp-button__primary': (
        props.purpose === 'primary'
        || props.purpose === 'primaryAction'
        || props.purpose === 'primary-action'
    ),
    'dp-button__secondary': (
        props.purpose === 'secondary'
        || props.purpose === 'secondaryAction'
        || props.purpose === 'secondary-action'
    ),
    'dp-button__destructive': (
        props.purpose === 'destructive'
        || props.purpose === 'destructiveAction'
        || props.purpose === 'destructive-action'
    ),
    'dp-button--tiny': props.size === 'tiny',
    'dp-button--small': props.size === 'small',
    'dp-button--default': props.size === 'default',
    'dp-button--large': props.size === 'large',
    'dp-button--grand': props.size === 'grand',
    'dp-button--inactive': props.inactive
  }
})
</script>

<script>
export default {
  name: "DpButton"
}
</script>

<template>
  <button class="dp-button" :class="classes" :disabled="inactive">
    <slot name="prefix"></slot>
    <slot>{{label}}</slot>
    <slot name="suffix"></slot>
  </button>
</template>

<style lang="scss" scoped>

</style>